import api from "../client.ts";

export type PonctualiteType = {
  id: number;
  eleve_id: number;
  jour: string; // format: YYYY-MM-DD
  heure_arrivee: string | null; // format: HH:MM:SS or null
  heure_sortie: string | null; // format: HH:MM:SS or null
  status_justif: number;
  justification: string | null;
  cote_eleve_id: number;
  terminal_id: number;
  status: number;
  created_at: string; // format: YYYY-MM-DD HH:MM:SS
  updated_at: string | null; // format: YYYY-MM-DD HH:MM:SS or null
};

export type PonctualitePersonalType = {
  id: number;
  jour: string; // e.g. "2025-10-07"
  heure_arrivee: string | null;
  heure_sortie: string | null;
  justification: string;
  status_justif: number;
  cote_enseignant_id: number;
  personnel_id: number;
  terminal_id: number;
  status: number;
  created_at: string;
  updated_at: string | null;
};

export const studentAttendanceController = {
  getAll: async (): Promise<{ size: number; data: PonctualiteType[] }> => {
    const { data } = await api.get("/ponctualite_eleve/readAll");
    return data;
  },
  getAllActive: async () => {
    const { data } = await api.get("/ponctualite_eleve/readActive");
    return data;
  },
  getAllByMonth: async (date: any) => {
    const { data } = await api.get(
      `/ponctualite_eleve/readByMonth?jour=${date}`,
    );
    return data;
  },
  createEntrance: async (newRecord: any) => {
    const { data } = await api.post(
      "/ponctualite_eleve/createEntrance",
      newRecord,
    );
    return data;
  },
  createExit: async (newRecord: any) => {
    const { data } = await api.post("/ponctualite_eleve/createExit", newRecord);
    return data;
  },
  update: async (id: any, newRecord: any) => {
    const { data } = await api.put(
      `/ponctualite_eleve/update?id=${id}`,
      newRecord,
    );
    return data;
  },
  delete: async (id: any) => {
    const { data } = await api.delete(`/ponctualite_eleve/update?id=${id}`);
    return data;
  },
  desactive: async (id: any) => {
    const { data } = await api.patch(`/ponctualite_eleve/desactive?id=${id}`);
    return data;
  },
  active: async (id: any) => {
    const { data } = await api.patch(`/ponctualite_eleve/active?id=${id}`);
    return data;
  },
  getByPersonalId: async (personalId: any) => {
    const { data } = await api.get(
      `/ponctualite_eleve/readById?id=${personalId}`,
    );
    return data;
  },
};
export const personalAttendanceController = {
  getAll: async (): Promise<{
    size: number;
    data: PonctualitePersonalType[];
  }> => {
    const { data } = await api.get("/ponctualite_enseignant/readAll");
    return data;
  },
  getAllActive: async () => {
    const { data } = await api.get("/ponctualite_enseignant/readActive");
    return data;
  },
  createEntrance: async (newRecord: any) => {
    const { data } = await api.post(
      "/ponctualite_enseignant/createEntrance",
      newRecord,
    );
    return data;
  },
  createExit: async (newRecord: any) => {
    const { data } = await api.post(
      "/ponctualite_enseignant/createExit",
      newRecord,
    );
    return data;
  },
  update: async (id: any, newRecord: any) => {
    const { data } = await api.put(
      `/ponctualite_enseignant/update?id=${id}`,
      newRecord,
    );
    return data;
  },
  delete: async (id: any) => {
    const { data } = await api.delete(
      `/ponctualite_enseignant/update?id=${id}`,
    );
    return data;
  },
  desactive: async (id: any) => {
    const { data } = await api.patch(
      `/ponctualite_enseignant/desactive?id=${id}`,
    );
    return data;
  },
  active: async (id: any) => {
    const { data } = await api.patch(
      `/ponctualite_enseignant/active?id= ${id}`,
    );
    return data;
  },
  getByPersonalId: async (personalId: any) => {
    const { data } = await api.get(
      `/ponctualite_enseignant/readById?id=${personalId}`,
    );
    return data;
  },
};
